/* ==========================================================================
   BodenWerk – Ereignisse fuer die offenen Fragen der Bestandsaufnahme

   Sechs Ereignisse, die jeweils genau eine Frage beantworten sollen. Mehr
   nicht: weniger Daten heisst weniger Begruendungspflicht.

   Rechtlicher Rahmen:
   - Es wird ausschliesslich ueber Shopifys eigene Analyse gemeldet
     (shopify.analytics.publish). Kein zusaetzlicher Dienstleister, kein
     zusaetzliches Cookie, keine Drittlandsuebermittlung.
   - Gemeldet wird erst nach Einwilligung in die Kategorie Statistik. Vorher
     und nach Widerruf werden Ereignisse verworfen, nicht zwischengespeichert.
   - Die Nutzdaten enthalten keine personenbezogenen Angaben: Raumflaeche in
     Quadratmetern, Verschnitt in Prozent, Paketzahl, Produkt-Handle und
     gerundete Warenkorbwerte.

   Dokumentiert in 06-DATENSCHUTZERKLAERUNG.md, 07-COOKIE-UND-CONSENT-HINWEISE.md
   und 13-VERZEICHNIS-VERARBEITUNGSTAETIGKEITEN.md.
   ========================================================================== */
(function () {
  'use strict';

  // Die Einwilligungs-API ist im Theme nicht von sich aus da, sie muss ueber
  // Shopify.loadFeatures nachgeladen werden. Vorher gibt es keine verlaessliche
  // Auskunft, also wird bis dahin nichts gemeldet.
  var API_BEREIT = false;

  function ladeEinwilligungsAPI() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (fehler) { API_BEREIT = !fehler; }
    );
  }

  function pruefeEinwilligung() {
    if (!API_BEREIT) return false;
    try {
      var cp = window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
    } catch (e) {
      return false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ladeEinwilligungsAPI);
  } else {
    ladeEinwilligungsAPI();
  }

  function melde(name, daten) {
    if (!pruefeEinwilligung()) return; // ohne Einwilligung: verwerfen, nicht puffern
    try {
      // Grosses S: window.shopify gibt es im Storefront-Kontext nicht.
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, daten || {});
    } catch (e) {}
  }

  // Mehrfaches Melden desselben Zustands vermeiden.
  var zuletzt = {};
  function meldeEinmal(name, schluessel, daten) {
    if (zuletzt[name] === schluessel) return;
    zuletzt[name] = schluessel;
    melde(name, daten);
  }

  window.bwEreignis = { melde: melde, meldeEinmal: meldeEinmal, erlaubt: function () { return pruefeEinwilligung(); } };

  // Frage: Fuehrt der Musterweg zum Kauf oder ersetzt er ihn?
  // Delegiert, damit es auch fuer spaeter nachgeladene Abschnitte gilt.
  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest('[data-bw-weg]') : null;
    if (!ziel) return;
    melde('bw_weg_gewaehlt', { weg: ziel.getAttribute('data-bw-weg') });
  });
})();
